module.exports = __webpack_public_path__ + "static/img/Dan-Hannebery.1d6f3db.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Dan-Hannebery.jpg
// module id = qVxb
// module chunks = 0